<h1 class="page-title mb-5">الشباب والابتكار</h1>
<div>
  <div>
  </div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9 my-5">
        <h4>الشباب والابتكار</h4>
        <p>
          توفر القوى العاملة الشابة والمتعلمة في مصر للمستثمرين إمكانية الوصول
          إلى العمالة الموهوبة. ساعد شغفهم وإبداعهم ، إلى جانب الدعم التشريعي ،
          في وضع مصر بين أفضل 10 دول في العالم لإطلاق شركات ناشئة ، وفقًا لشركة
          فوربس في عام 2015.
        </p>
        <p>
          تفتخر مصر بقوة عاملة كبيرة ، شابة ، مدربة تدريباً جيداً وتنافسية عالية
          تبلغ حوالي 29.1 مليون (أي أكثر من 31٪ من إجمالي السكان المصريين).
        </p>
        <p>
          مع تعداد سكانها الصاخبين بأكثر من 100 مليون نسمة ، 50٪ منهم تقل
          أعمارهم عن 30 عامًا ، فإن مصر تعلن بقوة عن مطالبتها باعتبارها واحدة من
          أسرع مراكز الأعمال نموًا في العالم.
        </p>
        <p>
          تقع المعرفة والابتكار والبحث العلمي في قلب استراتيجية التنمية
          الاجتماعية لعام 2030 في مصر.
        </p>
        <p>تتضمن هذه الإستراتيجية أيضًا:</p>
        <p>
          تنفيذ الإصلاح القانوني لتعزيز الابتكار. اعتماد برنامج شامل لتعزيز
          الابتكار والثقافة المعرفة. برنامج شامل لتحفيز أنشطة الابتكار من قبل
          الشركات الصغيرة والمتوسط
        </p>
        <h4>فكرتك شركتك</h4>
        <p>
          مبادرة فكرتك شركتك هي عبارة عن منصة تم إطلاقها في يوليو 2013 لدعم
          مشاريع ريادة الأعمال في مختلف القطاعات ومراحل النمو المختلفة. يوفر
          دعمًا شاملاً لأصحاب المشاريع الناشئة والشركات الناشئة في مصر ، ويزيد
          من وعي ريادة الأعمال ويبني قدرات الشباب من خلال مجموعة واسعة من
          الأنشطة بما في ذلك الدورات التدريبية وورش العمل ، وبرامج توجيه الأعمال
          الفردية ، والاستشارات القانونية ، والعمل المشترك الفضاء.
        </p>
        <h4>
          <a
            href="https://www.gafi.gov.eg/arabic/pages/loginuser.aspx?ReturnUrl=%2Farabic%2FeServices%2Fduring%2Dinauguration%2FPages%2Fdefault%2Easpx">
            ISC والخدمات الإلكترونية
          </a>
        </h4>

        <p>
          يمكن تأسيس الشركة بموجب قانون الشركات أو قانون الاستثمار في مصر - في
          يوم واحد - في مركز خدمات المستثمر أو عبر الإنترنت ، مما يخدم
          المستثمرين مع العديد من الخدمات التي تتراوح بين تأسيس الشركة
          والاندماجات وعمليات الدمج والتصفية والشهادات مستندات المستثمرين ،
          تسجيل الأصول وأكثر من ذلك. كان تركيزنا عند تطوير مركز الدراسات الدولي
          هو تسهيل القيام بالأعمال التجارية في مصر. وآخرها إنشاء المركز الذي
          يهدف إلى الحد من الإجراءات البيروقراطية وتقديم الخدمات الإلكترونية
          للمستثمرين. يوفر لك أسابيع أو حتى أشهر من الأعمال الورقية ، أطلقنا
          نظامًا آليًا مع قائمة الانتظار الإلكترونية والتوقيع الإلكتروني ،
          ويمكنك إنشاء شركتك في غضون ساعات قليلة بحد أقصى يوميًا. لإنشاء شركة ،
          يتعين عليك متابعة تسجيل الشركة نفسها وتسجيل اسم الشركة ، لأسباب تتعلق
          بحقوق الطبع والنشر ، ويمكنك الآن القيام بكل هذا عبر الإنترنت. يجمع
          المركز الجديد جميع الوكالات التي قد يحتاجها المستثمر في مكان واحد ،
          بما في ذلك مكتب تسجيل Real East ، والسجل التجاري ، وغرف التجارة وهيئة
          التنظيم المالي. بشكل عام ، يضم ممثلين عن 66 وزارة وهيئات حكومية مفوضين
          بالتوقيع على الوثائق. علاوة على ذلك ، يقدم المركز المشورة القانونية مع
          التركيز على الشركات الناشئة. أي كيان يحتاج المستثمر إلى التعامل معه
          لإنشاء شركة أو لإصدار ترخيص متاح في المركز. </p>
        <span><a target="_blank"
            href="https://www.gafi.gov.eg/arabic/pages/loginuser.aspx?ReturnUrl=%2Farabic%2FeServices%2Fduring%2Dinauguration%2FPages%2Fdefault%2Easpx">انقر
            هنا</a></span>
        <h4>
          <a target="_blank" href="https://www.investinegypt.gov.eg/Arabic/Pages/explore.aspx?map=true">خريطة
            الاستثمار</a>
        </h4>
        <p>
          من خلال خريطة الاستثمار الخاصة بنا ، يمكننا عرض جميع الفرص الاستثمارية
          المتاحة بشكل مرئي بشكل واضح ، بالإضافة إلى تفاصيل جميع المعلومات
          والبيانات التي يحتاجها المستثمرون المحليون والأجانب. تهدف خريطة
          الاستثمار إلى نقل مصر على خريطة الاستثمار العالمية ، وتوفير 360 درجة
          عرض على مناخ الاستثمار في مصر. تتضمن خريطة الاستثمار معلومات عن
          المشاريع من جميع الأحجام ، والتي تشير إلى مدى قرب المشاريع من المنشآت
          الرئيسية (روابط النقل والمدارس والمستشفيات) وتوفر منصة يمكن للمستثمرين
          والمسؤولين الحكوميين الاتصال بها. علاوة على ذلك ، تشير الخريطة إلى
          موقع مشروعات التطوير المستمرة ، مما يمكّن المستثمرين من التخطيط
          للمستقبل.
        </p>
        <span><a target="_blank" href="https://www.investinegypt.gov.eg/Arabic/Pages/default.aspx">انقر هنا</a></span>

      </div>
      <div class="col-md-3">
        <app-fix-left-section></app-fix-left-section>
      </div>
    </div>
  </div>
</div>